import {
  ClientFeatureFlag,
  FeatureFlag,
  FeatureFlagStage,
  RemoteClientFeatureFlag,
  RemoteFeatureFlag,
  RemoteUserFeatureFlag,
  UserFeatureFlag,
} from './featureFlags.types';
import {DateTime} from 'luxon';
import {featureFlags} from '@cl/shared';
import _omit from 'lodash/omit';

const {allFrontendFlags} = featureFlags;

function toUIFeatureFlag(remoteFlag: RemoteFeatureFlag): FeatureFlag {
  return {
    id: remoteFlag.key,
    ..._omit(remoteFlag, ['creationDate', 'updateDate']),
    creationDate: !!remoteFlag.creationDate ? DateTime.fromISO(remoteFlag.creationDate) : null,
    updateDate: !!remoteFlag.updateDate ? DateTime.fromISO(remoteFlag.updateDate) : null,
    get isOn() {
      return this.stage === FeatureFlagStage.On;
    },
    get isOff() {
      return !this.isOn;
    },
    tags: remoteFlag.tags || [],
    isUsedInFrontend: allFrontendFlags.has(remoteFlag.key),
  };
}

function toUIClientFeatureFlag(remoteFlag: RemoteClientFeatureFlag): ClientFeatureFlag {
  return {
    id: `${remoteFlag.key}-client${remoteFlag.clientId}`,
    isOn: remoteFlag.value,
    get isOff() {
      return !this.isOn;
    },
    ...remoteFlag,
  };
}

function toUIUserFeatureFlag(remoteFlag: RemoteUserFeatureFlag): UserFeatureFlag {
  return {
    id: `${remoteFlag.key}-user${remoteFlag.userId}`,
    isOn: remoteFlag.value,
    get isOff() {
      return !this.isOn;
    },
    ...remoteFlag,
  };
}

export {toUIFeatureFlag, toUIClientFeatureFlag, toUIUserFeatureFlag};
